import { render } from "./ProductBillingPeriodsStatus.vue?vue&type=template&id=a871bbb4"
import script from "./ProductBillingPeriodsStatus.vue?vue&type=script&lang=js"
export * from "./ProductBillingPeriodsStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__